var render = function () {
  var _vm$currentRound, _vm$currentRound2, _vm$currentRound2$ans, _vm$currentRound2$ans2, _vm$currentRound3, _vm$currentRound3$ans, _vm$currentRound3$ans2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'puzzling-letters'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "puzzling-letters-container"
  }, [_c('div', {
    staticClass: "puzzling-letters-title"
  }, [_c('h2', [_vm._v(_vm._s((_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.answer))])]), _c('div', {
    staticClass: "background-image-container"
  }, [_c('img', {
    staticClass: "background-image",
    class: {
      isMobile: _vm.isMobile
    },
    attrs: {
      "alt": (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$ans = _vm$currentRound2.answerImage) === null || _vm$currentRound2$ans === void 0 ? void 0 : (_vm$currentRound2$ans2 = _vm$currentRound2$ans.image) === null || _vm$currentRound2$ans2 === void 0 ? void 0 : _vm$currentRound2$ans2.description,
      "src": (_vm$currentRound3 = _vm.currentRound) === null || _vm$currentRound3 === void 0 ? void 0 : (_vm$currentRound3$ans = _vm$currentRound3.answerImage) === null || _vm$currentRound3$ans === void 0 ? void 0 : (_vm$currentRound3$ans2 = _vm$currentRound3$ans.image) === null || _vm$currentRound3$ans2 === void 0 ? void 0 : _vm$currentRound3$ans2.src
    }
  })]), _c('div', {
    staticClass: "puzzle-letters-container focusable",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "puzzle-piece-container absolute-puzzle-01"
  }, [_c('svg', {
    staticClass: "puzzlepiece01",
    attrs: {
      "height": "220px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlepiece01)
    }
  }), _c('svg', {
    staticClass: "puzzle-outline",
    attrs: {
      "width": "80px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlingoutline)
    }
  }), _c('div', {
    staticClass: "puzzle-piece"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentRound.letter))])])]), _c('div', {
    staticClass: "puzzle-piece-container absolute-puzzle-02"
  }, [_c('svg', {
    staticClass: "puzzlepiece02",
    attrs: {
      "height": "179px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlepiece02)
    }
  }), _c('svg', {
    staticClass: "puzzle-outline",
    attrs: {
      "width": "80px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlingoutline)
    }
  }), _c('div', {
    staticClass: "puzzle-piece"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentRound.letter))])])]), _c('div', {
    staticClass: "puzzle-piece-container absolute-puzzle-03"
  }, [_c('svg', {
    staticClass: "puzzlepiece03",
    attrs: {
      "height": "220px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlepiece03)
    }
  }), _c('svg', {
    staticClass: "puzzle-outline",
    attrs: {
      "width": "80px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlingoutline)
    }
  }), _c('div', {
    staticClass: "puzzle-piece"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentRound.letter))])])]), _c('div', {
    staticClass: "puzzle-piece-container absolute-puzzle-04"
  }, [_c('svg', {
    staticClass: "puzzlepiece04",
    attrs: {
      "height": "188px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlepiece04)
    }
  }), _c('svg', {
    staticClass: "puzzle-outline",
    attrs: {
      "width": "80px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlingoutline)
    }
  }), _c('div', {
    staticClass: "puzzle-piece"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentRound.letter))])])]), _c('div', {
    staticClass: "puzzle-piece-container absolute-puzzle-05"
  }, [_c('svg', {
    staticClass: "puzzlepiece05",
    attrs: {
      "height": "235px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlepiece05)
    }
  }), _c('svg', {
    staticClass: "puzzle-outline",
    attrs: {
      "width": "80px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlingoutline)
    }
  }), _c('div', {
    staticClass: "puzzle-piece"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentRound.letter))])])]), _c('div', {
    staticClass: "puzzle-piece-container absolute-puzzle-06"
  }, [_c('svg', {
    staticClass: "puzzlepiece06",
    attrs: {
      "height": "154px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlepiece06)
    }
  }), _c('svg', {
    staticClass: "puzzle-outline",
    attrs: {
      "width": "80px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.puzzlingoutline)
    }
  }), _c('div', {
    staticClass: "puzzle-piece"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentRound.letter))])])])])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }